import React, { useState } from 'react';
import { Row, Col, Form, Input, Button, message, Result } from 'antd';
import { TopSection } from './About'; // Assuming TopSection is a common header component
import axios from 'axios';
import { SmileOutlined } from '@ant-design/icons';

const AffiliateProgramForm = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const onFinish = async (values) => {
        setLoading(true);
        try {
            // You'll need a new API endpoint for affiliate program applications
            await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/affiliate-applications`, values);
            form.resetFields();
            setSubmitted(true);
            setLoading(false);
        } catch (error) {
            console.error('Error submitting affiliate application:', error);
            message.error('Failed to submit your affiliate application. Please try again later.');
            setLoading(false);
        }
    };

    if (submitted) {
        return (
            <>
                <TopSection heading={'Affiliate Program'} />
                <div
                    style={{
                        padding: '60px 20px',
                        minHeight: '60vh',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Result
                        icon={<SmileOutlined style={{ color: '#ff4d4f' }} />}
                        title={<h2 style={{ color: '#ff4d4f', fontSize: '32px' }}>Thank You for Your Interest!</h2>}
                        subTitle={
                            <p style={{ fontSize: '18px', fontFamily: 'Outfit, sans-serif' }}>
                                We've received your application for the affiliate program and will review it soon.
                            </p>
                        }
                        extra={
                            <Button
                                type="primary"
                                onClick={() => setSubmitted(false)}
                                style={{
                                    backgroundColor: '#ff814a',
                                    borderColor: '#ff814a',
                                    fontWeight: 'bold',
                                    borderRadius: 20,
                                    fontSize: '16px',
                                    fontFamily: 'Outfit, sans-serif',
                                }}
                            >
                                Submit Another Application
                            </Button>
                        }
                    />
                </div>
            </>
        );
    }

    return (
        <>
            <TopSection heading={'Join Our Affiliate Program'} />

            <div style={{ padding: '60px 20px' }}>
                <Row justify="center" gutter={[32, 32]} style={{ maxWidth: 1100, margin: 'auto' }}>
                    {/* Left Info Block - Provide information about the affiliate program */}
                    <Col xs={24} md={12}>
                        <div style={{ paddingLeft: 20, fontSize: '18px' }}>
                            <h3 style={{ color: '#ff4d4f', fontWeight: 'bold', fontSize: '22px' }}>Why Partner With Us?</h3>
                            <ul style={{ lineHeight: 1.8, fontFamily: 'Outfit, sans-serif', paddingLeft: 20 }}>
                                <li>Earn generous commissions on every successful referral.</li>
                                <li>Access to marketing materials and dedicated support.</li>
                                <li>Partner with a trusted and growing brand.</li>
                                <li>Flexible terms and timely payouts.</li>
                            </ul>


                        </div>
                    </Col>

                    {/* Right Form Block */}
                    <Col xs={24} md={12}>
                        <div
                            style={{
                                border: '2px dashed red',
                                borderRadius: 50,
                                padding: 30,
                                background: '#fff',
                            }}
                        >
                            <h2 style={{ textAlign: 'center', marginBottom: 20, fontSize: '26px' }}>Affiliate Application</h2>
                            <Form
                                form={form}
                                layout="vertical"
                                style={{ fontSize: '16px' }}
                                onFinish={onFinish}
                            >
                                <Form.Item
                                    name="fullName"
                                    label="Full Name"
                                    rules={[{ required: true, message: 'Please enter your full name' }]}
                                >
                                    <Input
                                        placeholder="Enter Full name"
                                        className="newsletter-input"
                                        style={{ fontFamily: 'Outfit, sans-serif', fontSize: '16px' }}
                                    />
                                </Form.Item>
                                <Form.Item
                                    name="mobile"
                                    label="Mobile Number"
                                    rules={[{ required: true, message: 'Please enter your mobile number' }]}
                                >
                                    <Input
                                        placeholder="Enter Mobile No."
                                        className="newsletter-input"
                                        style={{ fontFamily: 'Outfit, sans-serif', fontSize: '16px' }}
                                    />
                                </Form.Item>
                                <Form.Item
                                    name="email"
                                    label="Email"
                                    rules={[
                                        { required: true, message: 'Please enter your email' },
                                        { type: 'email', message: 'Please enter a valid email' },
                                    ]}
                                >
                                    <Input
                                        className="newsletter-input"
                                        placeholder="Email"
                                        style={{ fontFamily: 'Outfit, sans-serif', fontSize: '16px' }}
                                    />
                                </Form.Item>
                                <Form.Item
                                    name="websiteOrSocial"
                                    label="Website/Social Media Link (Optional)"
                                    tooltip="Provide a link to your website, blog, or main social media profile to help us understand your reach."
                                >
                                    <Input
                                        className="newsletter-input"
                                        placeholder="e.g., https://yourwebsite.com or https://instagram.com/yourprofile"
                                        style={{ fontFamily: 'Outfit, sans-serif', fontSize: '16px' }}
                                    />
                                </Form.Item>
                                <Form.Item
                                    name="howYouHeard"
                                    label="How did you hear about us?"
                                >
                                    <Input.TextArea
                                        placeholder="Tell us how you learned about our affiliate program."
                                        rows={2}
                                        className="newsletter-input"

                                        style={{
                                            fontFamily: 'Outfit, sans-serif',
                                            fontSize: '16px',
                                        }}
                                    />
                                </Form.Item>
                                <Form.Item
                                    name="message"
                                    label="Additional Message (Optional)"
                                >
                                    <Input.TextArea
                                        placeholder="Any other information you'd like to share?"
                                        rows={3}
                                        className="newsletter-input"

                                        style={{
                                            fontFamily: 'Outfit, sans-serif',
                                            fontSize: '16px',
                                        }}
                                    />
                                </Form.Item>
                                <Form.Item>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        block
                                        loading={loading}
                                        style={{
                                            backgroundColor: '#ff814a',
                                            borderColor: '#ff814a',
                                            fontWeight: 'bold',
                                            width: 150,
                                            justifyContent: 'center',
                                            display: 'flex',
                                            margin: 'auto',
                                            borderRadius: 20,
                                            fontSize: '16px',
                                            fontFamily: 'Outfit, sans-serif',
                                        }}
                                    >
                                        Apply Now
                                    </Button>
                                </Form.Item>
                            </Form>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    );
};

export default AffiliateProgramForm;